<!--<h1 mat-dialog-title>Hi {{data.name}}</h1>-->
<form [formGroup]="dialogoGroup">
<h1 mat-dialog-title>Información a Modificar</h1>
<div mat-dialog-content>
  <!--<p>Información a Modificar</p>-->
  <mat-form-field>
    <mat-label>Orden</mat-label>
    <input  formControlName="txtTitulo" matInput [(ngModel)]="data.titulo">
  </mat-form-field>
  <mat-form-field>
    <mat-label>Descripción</mat-label>
    <input  formControlName="txtSubTitulo" matInput [(ngModel)]="data.subTitulo">
  </mat-form-field>
  <mat-form-field>
    <mat-label>Valor</mat-label>
    <input  formControlName="txtCodigo" matInput [(ngModel)]="data.codigo">
  </mat-form-field>
  <mat-form-field>
    <mat-label>Bloque</mat-label>
    <mat-select formControlName="cbxBloques">
      <mat-option (onSelectionChange)="changeCbxBloques($event)" *ngFor="let item of listaBloques"
        [value]="item.id">
        {{item.valor}}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <mat-form-field class="invisible">
    <mat-label>Valor</mat-label>
    <input formControlName="txtDescripcionBloque" matInput [(ngModel)]="data.descripcionBloque">
  </mat-form-field>
</div>
<div mat-dialog-actions>
  <button  mat-raised-button (click)="onNoClick()">Cancelar</button>
  <button [disabled]="!dialogoGroup.valid"  mat-raised-button [mat-dialog-close]="data" cdkFocusInitial>Actualizar</button>
</div>
</form>
